import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-support-bubble',
  templateUrl: './support-bubble.component.html',
  styleUrls: ['./support-bubble.component.less']
})
export class SupportBubbleComponent {
  @Input() url = 'https://xpantion.com/support/index.php?a=add&category=1';
  @Input() label = 'Soporte';
  @Input() icon = 'fas fa-headset';
  @Input() expanded = false;
}
